import { VertexDeclaration } from "../../RenderEngine/VertexDeclaration";
import { VertexElement } from "../../renders/VertexElement";
import { VertexElementFormat } from "../../renders/VertexElementFormat";
import { Byte } from "../../utils/Byte";
import { Sprite2DGeometry } from "./Sprite2DGeometry";
function createQuadIB(quadNum) {
    let ibbuf = new Byte(quadNum * 6 * 2);
    let ib = new Uint16Array(ibbuf.buffer);
    var idx = 0;
    var curvert = 0;
    for (var i = 0; i < quadNum; i++) {
        ib[idx++] = curvert;
        ib[idx++] = curvert + 2;
        ib[idx++] = curvert + 1;
        ib[idx++] = curvert;
        ib[idx++] = curvert + 3;
        ib[idx++] = curvert + 2;
        curvert += 4;
    }
    return ib;
}
export class MeshQuadTexture extends Sprite2DGeometry {
    static __int__() {
        MeshQuadTexture._fixib = createQuadIB(MeshQuadTexture._maxIB);
        MeshQuadTexture.VertexDeclarition = new VertexDeclaration(48, [
            new VertexElement(0, VertexElementFormat.Vector4, 0),
            new VertexElement(16, VertexElementFormat.Vector4, 1),
            new VertexElement(32, VertexElementFormat.Vector4, 2),
        ]);
    }
    constructor(vballoc = 4) {
        super(MeshQuadTexture.const_stride, vballoc, 4);
        this._curVBPos = 0;
    }
    onVBRealloc(buff) {
        this._vbFloat32Array = new Float32Array(buff);
    }
    onIBRealloc(buff) {
    }
    addQuad(pos, uv, color, useTex) {
        this.expVBSize(MeshQuadTexture.const_stride);
        var vbdata = this._vbFloat32Array;
        let r = ((color >>> 16) & 0xff) / 255.0;
        let g = ((color >>> 8) & 0xff) / 255.0;
        let b = (color & 0xff) / 255.0;
        let a = (color >>> 24) / 255.0;
        var cpos = this._curVBPos;
        var useTexVal = useTex ? 1 : 0;
        vbdata[cpos++] = pos[0];
        vbdata[cpos++] = pos[1];
        vbdata[cpos++] = uv[0];
        vbdata[cpos++] = uv[1];
        vbdata[cpos++] = b;
        vbdata[cpos++] = g;
        vbdata[cpos++] = r;
        vbdata[cpos++] = a;
        vbdata[cpos++] = useTexVal;
        cpos += 3;
        vbdata[cpos++] = pos[2];
        vbdata[cpos++] = pos[3];
        vbdata[cpos++] = uv[2];
        vbdata[cpos++] = uv[3];
        vbdata[cpos++] = b;
        vbdata[cpos++] = g;
        vbdata[cpos++] = r;
        vbdata[cpos++] = a;
        vbdata[cpos++] = useTexVal;
        cpos += 3;
        vbdata[cpos++] = pos[4];
        vbdata[cpos++] = pos[5];
        vbdata[cpos++] = uv[4];
        vbdata[cpos++] = uv[5];
        vbdata[cpos++] = b;
        vbdata[cpos++] = g;
        vbdata[cpos++] = r;
        vbdata[cpos++] = a;
        vbdata[cpos++] = useTexVal;
        cpos += 3;
        vbdata[cpos++] = pos[6];
        vbdata[cpos++] = pos[7];
        vbdata[cpos++] = uv[6];
        vbdata[cpos++] = uv[7];
        vbdata[cpos++] = b;
        vbdata[cpos++] = g;
        vbdata[cpos++] = r;
        vbdata[cpos++] = a;
        vbdata[cpos++] = useTexVal;
        cpos += 3;
        this._curVBPos = cpos;
        this._vertNum += 4;
        this._indexNum += 6;
    }
    clearMesh() {
        super.clearMesh();
        this._curVBPos = 0;
    }
    get ibBuffer() {
        return MeshQuadTexture._fixib.buffer;
    }
    get vertexDeclarition() {
        return MeshQuadTexture.VertexDeclarition;
    }
}
MeshQuadTexture.const_stride = 48;
MeshQuadTexture._maxIB = 16 * 1024;
